import React, { useState } from 'react';
import { useShop } from '../../context/ShopContext';
import { defaultTrustPillars } from '../../data/products';
import { 
  ShieldCheck, 
  Truck, 
  RefreshCw, 
  Award, 
  Save, 
  RotateCcw, 
  Sparkles,
  CheckCircle2
} from 'lucide-react';

export default function AdminTrustManager() {
  const { trustPillarsData, updateTrustPillars, addToast } = useShop();
  const [pillars, setPillars] = useState([...trustPillarsData]);

  const handleChange = (index, field, value) => {
    const updated = [...pillars];
    updated[index] = { ...updated[index], [field]: value };
    setPillars(updated);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateTrustPillars(pillars);
  };

  const handleReset = () => {
    setPillars(defaultTrustPillars);
    updateTrustPillars(defaultTrustPillars);
    addToast('Trust pillars reset to royal standards', 'info');
  };

  const renderIcon = (iconName) => {
    switch (iconName) {
      case 'Truck': return <Truck size={24} color="var(--gold-400)" />;
      case 'RefreshCw': return <RefreshCw size={24} color="var(--gold-400)" />;
      case 'Award': return <Award size={24} color="var(--gold-400)" />;
      default: return <ShieldCheck size={24} color="var(--gold-400)" />;
    }
  };

  return (
    <div style={{ maxWidth: '980px' }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1rem',
        marginBottom: '2rem'
      }}>
        <div>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', color: 'var(--gold-400)', fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', marginBottom: '0.3rem' }}>
            <Sparkles size={13} /> Hallmark & Trust Guarantees
          </div>
          <h2 style={{ fontSize: '1.6rem', fontWeight: 800, color: '#fff' }}>
            Brand Trust Pillars & <span className="text-gold-gradient">Guarantees</span>
          </h2>
          <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>
            Configure the 4 core guarantees displayed prominently on the storefront to reassure buyers on high-value gold and diamond orders.
          </p>
        </div>

        <button
          type="button"
          onClick={handleReset}
          className="btn btn-glass btn-sm"
          style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.8rem' }}
        >
          <RotateCcw size={14} />
          <span>Reset Defaults</span>
        </button>
      </div>

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '1.5rem'
        }}>
          {pillars.map((pillar, idx) => (
            <div
              key={pillar.id || idx}
              style={{
                background: '#13131e',
                border: '1px solid var(--border-subtle)',
                borderRadius: 'var(--radius-md)',
                padding: '1.5rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
                <div style={{
                  width: '46px',
                  height: '46px',
                  borderRadius: '50%',
                  background: 'rgba(212, 175, 55, 0.12)',
                  border: '1px solid var(--border-gold)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  {renderIcon(pillar.iconName)}
                </div>
                <div style={{ fontWeight: 800, color: '#fff', fontSize: '1rem' }}>
                  Pillar #{idx + 1}
                </div>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.74rem', fontWeight: 700, color: 'var(--gold-400)', marginBottom: '0.3rem', textTransform: 'uppercase' }}>
                  Guarantee Title
                </label>
                <input
                  type="text"
                  required
                  value={pillar.title}
                  onChange={(e) => handleChange(idx, 'title', e.target.value)}
                  className="input-luxury"
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.74rem', fontWeight: 700, color: 'var(--gold-400)', marginBottom: '0.3rem', textTransform: 'uppercase' }}>
                  Guarantee Description
                </label>
                <textarea
                  rows={2}
                  required
                  value={pillar.desc}
                  onChange={(e) => handleChange(idx, 'desc', e.target.value)}
                  className="input-luxury"
                  style={{ resize: 'vertical' }}
                />
              </div>
            </div>
          ))}
        </div>

        <div>
          <button
            type="submit"
            className="btn btn-gold"
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.8rem 2rem' }}
          >
            <Save size={16} />
            <span>Save Guarantees to Storefront</span>
          </button>
        </div>
      </form>
    </div>
  );
}
